import * as React from "react"
import { Container, Row, Col } from "react-bootstrap"
import PageWrapper from "@app/components/PageWrapper"
import { useNavigate } from "react-router-dom"
import Config from "@app/constants/Config"
import FeedbackForm from "@app/components/FeedbackForm"

export async function action ({ request }) {
	const formData = await request.formData()
	const payload = await Object.fromEntries(formData.entries())

	try {
		await fetch(Config.API.FEEDBACK.SAVE,{
			method: "POST",
			headers: { "Content-Type": "application/json" },
			credentials: "include",
			body: JSON.stringify(payload),
		})
		return { ok: true };
	} catch (err) {
		return { ok: false, error: "Submission error" };
	}

	return null
}

export default function Feedback () {
	const navigate = useNavigate();
	return (
		<PageWrapper valign={"center"}
					 buttons={[
						 {
							 label: "Zurück zur Übersicht",
							 type: "secondary",
							 onClick: () => {
								 navigate(`${Config.BASE_PATH}/`)
							 },
						 },
					 ]}
		><Container>
			<Row>
				<Col className={"mb-120"}>
					<FeedbackForm variant={"page"} />
				</Col>
			</Row>
		</Container>
		</PageWrapper>
	)
}
